import {
  Notification_Category,
  Notification_ReadState,
} from '@wavingroup/iot-core/gen/ts/wavin/blaze/v1/notification_pb';
import { blazeDevicePromiseClient } from '~/services/blaze-device-client';

const NOTIFICATIONS_PAGE_SIZE = BigInt(20);

interface ListNotificationsParams {
  pageToken?: string;
  skip?: bigint;
  readStateFilter?: Notification_ReadState;
  categoryFilter?: Notification_Category;
  filterDeviceName?: string;
}

export const listNotifications = async ({
  pageToken = '',
  skip = BigInt(0),
  readStateFilter = Notification_ReadState.UNSPECIFIED,
  categoryFilter,
  filterDeviceName = '',
}: ListNotificationsParams = {}) => {
  const data = await blazeDevicePromiseClient.listNotifications({
    pageSize: NOTIFICATIONS_PAGE_SIZE,
    pageToken,
    skip,
    readStateFilter,
    categoryFilter,
    filterDeviceName,
  });

  return data;
};
